module.exports = __webpack_public_path__ + "static/media/25.6d5426ae.jpeg";